class RuqyCartCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ruqy-cart-track]');
    this.slides = Array.from(this.querySelectorAll('[data-ruqy-cart-slide]'));
    this.previousButton = this.querySelector('[data-ruqy-cart-prev]');
    this.nextButton = this.querySelector('[data-ruqy-cart-next]');
    this.currentLabel = this.querySelector('[data-ruqy-cart-current]');

    if (!this.track || this.slides.length === 0) return;

    this.onPrevious = () => this.goTo(this.currentIndex - 1);
    this.onNext = () => this.goTo(this.currentIndex + 1);
    this.onScroll = () => this.requestUpdate();
    this.onKeyDown = (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.goTo(this.currentIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.goTo(this.currentIndex + 1);
      }
    };

    this.previousButton?.addEventListener('click', this.onPrevious);
    this.nextButton?.addEventListener('click', this.onNext);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.track.addEventListener('keydown', this.onKeyDown);
    this.updateState();
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.onPrevious);
    this.nextButton?.removeEventListener('click', this.onNext);
    this.track?.removeEventListener('scroll', this.onScroll);
    this.track?.removeEventListener('keydown', this.onKeyDown);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  get currentIndex() {
    if (!this.track || this.track.clientWidth === 0) return 0;
    return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
  }

  goTo(index) {
    if (!this.track) return;
    const nextIndex = Math.max(0, Math.min(this.slides.length - 1, index));
    this.track.scrollTo({ left: nextIndex * this.track.clientWidth, behavior: 'smooth' });
  }

  requestUpdate() {
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.updateState());
  }

  updateState() {
    const index = this.currentIndex;
    if (this.currentLabel) this.currentLabel.textContent = String(index + 1);
    if (this.previousButton) this.previousButton.disabled = index === 0;
    if (this.nextButton) this.nextButton.disabled = index === this.slides.length - 1;
  }
}

if (!customElements.get('ruqy-cart-carousel')) {
  customElements.define('ruqy-cart-carousel', RuqyCartCarousel);
}
